/**
 * Same rules as HealBid_Backend/utils/validators.js validateEmail (keep in sync).
 * Doctor/hospital signup + signup thunk.
 */

const ALLOWED_EMAIL_PROVIDER_DOMAINS = new Set([
  "gmail.com",
  "googlemail.com",
  "yahoo.com",
  "yahoo.co.in",
  "yahoo.co.uk",
  "yahoo.in",
  "ymail.com",
  "hotmail.com",
  "hotmail.co.uk",
  "hotmail.fr",
  "outlook.com",
  "live.com",
  "msn.com",
]);

const EMAIL_HOSTNAME_RE = /^[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)+$/;

export function validateEmailInput(value) {
  if (value == null || typeof value !== "string") {
    return { valid: false, message: "Email is required" };
  }
  const trimmed = value.trim();
  if (!trimmed) return { valid: false, message: "Email is required" };
  const cleaned = trimmed.toLowerCase();
  if (cleaned.length > 254) return { valid: false, message: "Email is too long" };

  const atCount = (cleaned.match(/@/g) || []).length;
  if (atCount !== 1) {
    return { valid: false, message: "Please enter a valid email address" };
  }

  const [local, domain] = cleaned.split("@");
  if (!local || !domain) {
    return { valid: false, message: "Please enter a valid email address" };
  }
  if (local.length > 64) return { valid: false, message: "Email local part is too long" };
  if (local.includes("..") || domain.includes("..")) {
    return { valid: false, message: "Please enter a valid email address" };
  }

  const LOCAL_RE = /^[a-z0-9]([a-z0-9._+-]*[a-z0-9])?$/;
  if (!LOCAL_RE.test(local)) {
    return { valid: false, message: "Please enter a valid email address" };
  }

  if (!EMAIL_HOSTNAME_RE.test(domain)) {
    return { valid: false, message: "Please enter a valid email address" };
  }

  if (!ALLOWED_EMAIL_PROVIDER_DOMAINS.has(domain)) {
    return {
      valid: false,
      message:
        "Use an email from Gmail, Yahoo, Ymail, Hotmail, or Outlook (e.g. @gmail.com, @yahoo.com, @outlook.com).",
    };
  }

  return { valid: true, cleaned };
}
